import { render } from "./SimilarMovie.vue?vue&type=template&id=6946c73a"
import script from "./SimilarMovie.vue?vue&type=script&lang=js"
export * from "./SimilarMovie.vue?vue&type=script&lang=js"

import exportComponent from "F:\\Project Coustomer\\vue film\\film\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__